import BulletPoints from '~publish/legacy/shared-components/BulletPoints/BulletPoints'

import translations from '~publish/legacy/i18n/translations/en-us.json'
import { Heading } from '@buffer-mono/popcorn'

import styles from './PaywallModal.module.css'

/**
 * This component is used to render the content of the paywall
 * in the Paywall component.
 * In order to use it, you need to pass the key of the object
 * that contains the texts in en-us.json file and the link of the
 * image that will be displayed.
 *
 * Example for object in en-us.json:
 *
 * "hashtag-manager-paywall": {
 *   "title": "Upgrade your plan to save and organize hashtags",
 *  "plus": "Plus",
 *   "features": [
 *     "Advanced publishing tools",
 *     "Analytics & reporting",
 *     "Engagement tools"
 *   ],
 *  "buttonText": "See Upgrade Options"
 * },
 */

type ContentForSimplePaywallProps = {
  keyForTexts: string
  paywallImage: string
}

export const ContentForSimplePaywall = ({
  keyForTexts,
  paywallImage,
}: ContentForSimplePaywallProps): JSX.Element => {
  const paywallTexts = (translations as any)[keyForTexts]
  return (
    <div className={styles.paywallMainContent}>
      <img src={paywallImage} className={styles.paywallImage} alt="" />
      <Heading as="h3" data-testid="paywall-title">
        {paywallTexts.title}
      </Heading>
      <p className={`${styles.paywallSubHeading} ${styles.bold}`}>{paywallTexts.plus}</p>
      <BulletPoints items={paywallTexts.features} />
    </div>
  )
}
